import { ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { LocalDataSource } from 'ng2-smart-table';

import { Logger, AuthenticationService } from '@app/core';
import {
  BaseControl,
  ConfirmComponent,
  Const,
  Rol,
  Base,
  ReportePermisos,
  ReporteEstructura,
  PredeterminadoPermisoRol,
  CategoriaReporte
} from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { GroupsAdministrationForReportsConfigService } from './shared/groups-administration-for-reports.config.service';
import { GroupsAdministrationForReportsDataService } from './shared/groups-administration-for-reports.data.service';
import { GroupsAdministrationForReportsFormsService } from './shared/groups-administration-for-reports.form.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { find } from "rxjs/operators";

@Component({
    selector: "iw-groups-administration-for-reports",
    templateUrl: "./groups-administration-for-reports.html",
    styleUrls: ["./groups-administration-for-reports.scss"],
    providers: [
      GroupsAdministrationForReportsConfigService,
      GroupsAdministrationForReportsDataService,
      GroupsAdministrationForReportsFormsService
    ]
  })

 export class GroupsForadministrationComponent implements OnInit {
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Contiene el id del grupo seleccionado
  idGroupSelect = -1;
  // Contiene el id del tipo de permiso seleccionado
  idTypePermissionSelect: number = null;
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    delete: false,
    update: false
  };
  // Configuracion de la tabla
  settings = {};
  dataTable = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Contiene el permiso seleccionado
  permissionSelect: ReportePermisos;
  // Contiene los roles(Grupos) para listar en el select
  roles: Array<Rol> = [];
  // Contiene los tipos de permisos
  typesPermissions: Array<Base> = [];
  // Contiene los permisos
  permissions: Array<PredeterminadoPermisoRol> = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene los permisos del grupo seleccionado
  permissionsGroup: Array<ReportePermisos>;
  // formulario de agregar permisos
  form: FormGroup = new FormGroup({
    cboGroup: new FormControl(null),
  });
  formModal: FormGroup;
  // Contiene la lista de categorias de reportes
  categoryReportsDynamic: any[] = [];
  categoryReports: any[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngMultiSelect') ngMultiSelectSelectTpl: TemplateRef<any>;
  stateButton: boolean = false;
  action: string;
  idReport: number;
  currentReport: any;
  selectedReports: any[] = [];

  constructor(
    private gafrds: GroupsAdministrationForReportsDataService,
    private gafrfs: GroupsAdministrationForReportsFormsService,
    private as: AuthenticationService,
    private toastr: ToastrService,
  ){ }

  ngOnInit() {
    // determina los permisos del usuario en sesion
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.groupsAdministrationForReports,
      Const.types_action_permissions.reviewReport,
    );
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.groupsAdministrationForReports,
      Const.types_action_permissions.createReport,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.groupsAdministrationForReports,
      Const.types_action_permissions.deleteReport,
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.groupsAdministrationForReports,
      Const.types_action_permissions.updateReport,
    );
    const configTable = new GroupsAdministrationForReportsConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });
     
    this.gafrds.getRoles().subscribe(roles => this.roles = roles);
    this.gafrds.getTypePermission().subscribe(typePermissions => {
      if (typePermissions.length) {
        typePermissions.forEach(typePermission => {
          typePermission.nombre = typePermission.nombre.replace(/\_/g, ' ');
          typePermission.nombre = typePermission.nombre.charAt(0).toUpperCase() + typePermission.nombre.slice(1);
        });
        typePermissions.sort((a, b) => {
          if (a.nombre > b.nombre) {
            return 1;
          }
          if (a.nombre < b.nombre) {
            return -1;
          }
          return 0;
        });
        this.typesPermissions = typePermissions;
      }
    });
    this.form.controls['cboGroup'].valueChanges.subscribe(data => this.selectPermission(data));
    this.getCategoriesReports();
  }

   /**
   * Controla el evento de seleccionar un rol(Grupo) en el select principal
   *
   * @param {*} data
   * @memberof ManagementGroupsPermissionComponent
   */
     selectPermission(data: any) {
      if (this.activateAction.review) {
        if (data) {         
          this.idGroupSelect = data;
          this.gafrds.getPermissions(this.idGroupSelect).subscribe(async reports => {
            this.currentReport = reports;
            if (reports) {
              let reporte: any[] = [];
              await reports.forEach(report => {
                reporte.push({
                  id: report.reporte.id,
                  reporte: report.reporte.nombre,
                  codigo: report.reporte.codigo,
                  categoria: report.reporte.categoria
                })
              });
              this.sourceData = new LocalDataSource(reporte);
              this.sourceData.refresh();
              this.selectedReports = reporte;
            }           
          });        
        } else {
          this.idGroupSelect = -1;
        }
      } else {
        this.toastr.warning('Usted no posee permisos para ver los permisos de los reportes del sistema', 'Permiso denegado');
      }
    }

  /**
   * Obtiene las categorias
   */  
  getCategoriesReports() {
    this.gafrds.getCategoryReport().subscribe(data => {
      this.categoryReportsDynamic = data;
    });
  } 
  
  getReports(id: number): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      resolve
    })

  } 


  /**
   * Controla las acciones a realizar con los permisos
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ManagementGroupsPermissionComponent
   */
    defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) { 
    this.action = action;  
    switch (action) {
      case 'add':
        if (this.activateAction.created) {
          let options;
          this.formOpen = true;
          this.actionForm = 'Agregar';
          options = {
            categoryReports: this.categoryReportsDynamic,
            reportsOption: this.categoryReports
          }
          this.controls = this.gafrfs.getForm(options, this.ngSelectTpl);
        } else {
          this.toastr.error(
            'Usted no posee permisos para agregar permisos a los grupos del sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          let options;
          this.formOpen = true;
          this.actionForm = 'Modificar';
          this.permissionSelect = data;

          let dataReport: any[] = [];
          this.gafrds.getReportsbyCategory(data.categoria).subscribe(async dataR => {     
            if (dataR) {
              await dataR.reportes.forEach((report) => {
                dataReport.push({
                  id: report.id,
                  nombre: report.nombre
                })
              })
              this.categoryReports = dataReport;

              for (var i = 0; i < this.selectedReports.length; i++) {
                this.categoryReports.forEach((item, index, arr) => {
                  if (item.id == this.selectedReports[i].id && item.id != data.id) {
                    arr.splice(index, 1)
                  }
                })
              }

              options = {
                categoryReports: this.categoryReportsDynamic,
                reportsOption: this.categoryReports
              }
              let category = this.categoryReportsDynamic.find(c => c.id == data.categoria)
              let report = this.categoryReports.find(c => c.id == data.id)
              this.controls = this.gafrfs.getForm(options, this.ngSelectTpl, category, report);
            } else {
              this.categoryReports = dataReport;
              options = {
                categoryReports: this.categoryReportsDynamic,
                reportsOption: this.categoryReports
              }
              let category = this.categoryReportsDynamic.find(c => c.id == data.categoria)
              this.controls = this.gafrfs.getForm(options, this.ngSelectTpl, category);
            }
          });
          
        } else {
          this.toastr.error('Usted no posee permisos para modificar grupos en el sistema', 'Permiso denegado');
        }
        break;
        case 'delete':
        if (this.activateAction.delete) {
          this.permissionSelect = data;
          this.question = '¿Realmente desea eliminar el reporte?';
          this.confirm.open();
        } else {
          this.toastr.warning(
            'Usted no posee permisos para eliminar permisos a los reportes',
            'Permiso denegado'
          );
        }
        break;
    }
  }

  async sended(data: any) {
    switch(this.action) {
      case 'add':
        let dataRegister;
        dataRegister = {
          rol: this.idGroupSelect,
          reporte: data.reporte
        }
        this.gafrds.addPermissionReport(dataRegister).then(resp => {
          this.sourceData.refresh();
          this.closeForm();
        })
        
      break;

      case 'update':
        let dataUpdate;
        dataUpdate = {
          rol: this.idGroupSelect,
          reporte: data.reporte 
        }
        let idReport = this.currentReport.find((c: { reporte: { id: number; }; }) => c.reporte.id == this.permissionSelect.id) 
        this.gafrds.updatePermissionReport(idReport.id, dataUpdate).then(resp => {
          this.sourceData.refresh();
          this.closeForm();
        })
        
      break;
    }
    
  }

  closeForm() {
    this.formOpen = false;
    this.controls = [];
    this.sourceData.refresh();
    this.selectPermission(this.idGroupSelect);
  }

 /**
 * Controla la accion de confimacion del modal
 *
 * @param {boolean} res
 * @memberof ManagementGroupsComponent
 */
  actionComfirm(res: boolean) {
    if (res) {
      this.deletePermissionReports();
    }
    this.question = '';
  }

  private deletePermissionReports() {
    let deletePermission;
    deletePermission = {
      rol: this.idGroupSelect,
      reporte: this.permissionSelect.reporte
    }
    let idReport = this.currentReport.find((c: { reporte: { id: number; }; }) => c.reporte.id == this.permissionSelect.id) 
    this.gafrds.deletePermissionReport(idReport.id).then(() => {
      this.closeFormRol();
      this.sourceData.refresh();
      this.closeForm();
    }).catch(() => {
      this.closeFormRol();
    });
  }

  /**
   * Cierra la vista del formulario de creacion o edicion de un rol(Grupo)
   *
   * @memberof ManagementGroupsComponent
   */
   closeFormRol() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
  }  

  async changeform(data: any) {
    if(data.controlChanged == "categoria"){
      let dataReport: any[] = [];
      this.gafrds.getReportsbyCategory(data.change.categoria).subscribe(async dataR => {     
        if (dataR) {
          await dataR.reportes.forEach((report) => {
            dataReport.push({
              id: report.id,
              nombre: report.nombre
            })
          })
          this.categoryReports = dataReport;
          
          for (var i = 0; i < this.selectedReports.length; i++) {
            this.categoryReports.forEach((item, index, arr) => {
              if (item.id == this.selectedReports[i].id) {
                arr.splice(index, 1)
              }
            })
          }
          
          let options = {
            categoryReports: this.categoryReportsDynamic,
            reportsOption: this.categoryReports
          }
          let category = this.categoryReportsDynamic.find(c => c.id == data.change.categoria)
          this.controls = this.gafrfs.getForm(options, this.ngSelectTpl, category);
        } else {
          this.categoryReports = dataReport;
          this.controls.forEach(control => {
            if(control.key == 'reporte'){
              control['options'] = this.categoryReports;
              control['value'] = null;
            }
          });
        }
      });
    }
  }

  selectGroup(data: any){
    if (data && data.id) {
      this.stateButton = true;
    } else {
      this.stateButton = false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/groups-adminisration-for-reports/groups-administration-for-reports.ts